// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * System for testing observation category codes.
 */
export const POLARIS_TESTING_OBS_CATEGORY_SYSTEM = 'http://polarissleep.com/codes/testing-observation-category';

/**
 * Observation category codes that distinguish testing series.
 */
export const TESTING_OBS_CATEGORY = {
  patientLatestNullish: 'patient-latest-testing-nullish',
} as const;

/**
 * System for testing observation identifiers.
 */
export const TESTING_OBS_IDENTIFIER_SYSTEM = 'http://polarissleep.com/identifier/testing';

/**
 * Builds a deterministic identifier value for a nullish testing marker Observation.
 * Format: "nullish|<patientId>|<code>"
 * The `nullish|` prefix distinguishes marker identifiers from real Observation identifiers,
 * ensuring no identifier collision.
 * This enables idempotent UPSERT operations on re-run.
 */
export function buildNullishTestingMarkerIdentifier(patientId: string, code: string): string {
  return `nullish|${patientId}|${code}`;
}
